import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import { Campaign } from 'domains/campaigns/types';

import { UseQueryOptions } from '@tanstack/react-query';
import useQuery from '../useQuery';
import QueryKeys from './keys';

const useDraftCampaign = (campaignId: string, reactQueryOptions?: UseQueryOptions<Campaign, Error>) =>
    useQuery(
        QueryKeys.CURATION_ID(campaignId), // Reuse the same key structure for consistency
        new PathWithID(CuredApiPaths.CAMPAIGNS_DRAFT, campaignId),
        reactQueryOptions
    );

export default useDraftCampaign;
